import React from 'react';
import { branch } from 'recompose';
import { withRouter } from 'react-router';
import withCreatePage from 'hocs/extends/withCreatePage'
import withEditPage from 'hocs/extends/withEditPage'
import MenuController from './MenuController';

// const initialMenu = megaMenuData

const initialMenu = {
  name: 'Untitled',
  data: [],
};

const CreateOrEditMenu = (
  branch(
    props => props.params.id,
    withEditPage({
      resourceName: 'menu',
      getInitialResource: () => ({}),
    }),
    withCreatePage({
      resourceName: 'menu',
      initialState: initialMenu,
    })
  )
)(MenuController);

CreateOrEditMenu.propTypes = {};
CreateOrEditMenu.defaultProps = {};

export default withRouter(CreateOrEditMenu);



// WEBPACK FOOTER //
// ./src/pages/Menus/children/CreateOrEditMenu.js